import { useState } from 'react'
import { toRoman } from '@lunary/app-core/roman'
import { useFewshotCoverage } from './queries'
import { LibraryCard } from './library-card'
import styles from './studio.module.css'

export function Library() {
  const coverage = useFewshotCoverage()
  const [cardId, setCardId] = useState('')

  if (coverage.isPending) return <div className="spinner" aria-label="Загрузка" />
  if (coverage.isError) return <p className="error-box">Не удалось загрузить эталоны.</p>

  const { cards, per_card_limit: limit } = coverage.data
  const full = cards.filter((c) => c.active >= limit).length
  const selected = cards.find((c) => c.card_id === cardId) ?? cards[0]

  return (
    <div>
      <p className="muted">
        В подсказку модели для карты идут {limit} эталона: сначала закреплённые, потом самые свежие. Исключённые не
        используются. Полностью покрыто карт: {full} из {cards.length}.
      </p>
      <div className={styles.coverage} role="listbox" aria-label="Карты">
        {cards.map((c) => {
          const state = c.active >= limit ? styles.cellFull : c.active > 0 ? styles.cellPartial : styles.cellEmpty
          return (
            <button
              key={c.card_id}
              role="option"
              aria-selected={selected?.card_id === c.card_id}
              className={`${styles.cell} ${state} ${selected?.card_id === c.card_id ? styles.cellSelected : ''}`}
              onClick={() => setCardId(c.card_id)}
              title={`${c.card_name}: ${c.active} в работе, всего ${c.approved}`}
            >
              <span className={styles.cellNum}>{toRoman(c.card_number)}</span>
              <span className={styles.cellName}>{c.card_name}</span>
              <span className={styles.cellCount}>
                {Math.min(c.active, limit)}/{limit}
              </span>
            </button>
          )
        })}
      </div>
      {selected && <LibraryCard cardId={selected.card_id} cardName={selected.card_name} limit={limit} />}
    </div>
  )
}
